import { SHOW_TABBAR } from '../actionType/index';

const initState = {
  isShowTab: false,
};

export default (state = initState, action: any) => {
  switch(action.type) {
    case SHOW_TABBAR:
      return Object.assign({}, state, {isShowTab: action.payload});
    default:
      return state;
  }
}
// 是否显示该Tabbar
export const updateShowStatus = (payload: boolean) => {
  return {
    type: SHOW_TABBAR,
    payload
  }
}